export enum IndexingEngine {
  DTSearch = 1,
  Solr = 2,
  OpenSearch = 4,
}
